import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './hooks/useAuth';
import AdminLayout from './components/layout/AdminLayout';
import Login from './pages/auth/Login';
import Register from './pages/auth/register/Register';
import ForgotPassword from './pages/auth/forgot-password/ForgotPassword';
import ResetPassword from './pages/auth/reset-password/ResetPassword';
import Dashboard from './pages/dashboard/Dashboard';
import ProjectsList from './pages/projects/ProjectsList';
import ProjectForm from './pages/projects/ProjectForm';
import ServicesList from './pages/services/ServicesList';
import ServiceForm from './pages/services/ServiceForm';
import JobList from './pages/careers/JobList';
import JobForm from './pages/careers/JobForm';
import Applications from './pages/careers/Applications';
import MessagesList from './pages/messages/MessagesList';
import Settings from './pages/settings/Settings';
import MessageDetail from './pages/messages/MessageDetail';
import ContactMessageList from './pages/contact/ContactMessageList';
import ContactMessageDetails from './pages/contact/ContactMessageDetails';

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();
  return isAuthenticated? children : <Navigate to="/login" />;
};

const PublicRoute = ({ children }) => {
  const { isAuthenticated } = useAuth();
  return!isAuthenticated? children : <Navigate to="/" />;
};

const AppRoutes = () => {
  return (
    <Routes>
      {/* Public Routes */}
      <Route path="/login" element={<PublicRoute><Login /></PublicRoute>} />
      <Route path="/register" element={<PublicRoute><Register /></PublicRoute>} />
      <Route path="/forgot-password" element={<PublicRoute><ForgotPassword /></PublicRoute>} />
      <Route path="/reset-password" element={<PublicRoute><ResetPassword /></PublicRoute>} />

      {/* Protected Routes */}
      <Route path="/" element={<ProtectedRoute><AdminLayout /></ProtectedRoute>}>
        <Route index element={<Dashboard />} />
        
        <Route path="projects" element={<ProjectsList />} />
        <Route path="projects/add" element={<ProjectForm />} />
        <Route path="projects/edit/:id" element={<ProjectForm />} />
        
        <Route path="services" element={<ServicesList />} />
        <Route path="services/add" element={<ServiceForm />} />
        <Route path="services/edit/:id" element={<ServiceForm />} />
        
        <Route path="careers/jobs" element={<JobList />} />
        <Route path="careers/jobs/add" element={<JobForm />} />
        <Route path="careers/jobs/edit/:id" element={<JobForm />} />
        <Route path="careers/applications" element={<Applications />} />
        <Route path="careers/applications/:jobId" element={<Applications />} />
        
        <Route path="messages" element={<MessagesList />} />
        <Route path="messages/:id" element={<MessageDetail />} />

        <Route path="contact-messages" element={<ContactMessageList />} />
        <Route path="contact-messages/:id" element={<ContactMessageDetails />} />
        

        <Route path="settings" element={<Settings />} />
      </Route>
    </Routes>
  );
};
export default AppRoutes;